import React, { useEffect, useState, useRef } from "react";
import axios from 'axios';

import "./NotificationsModal.css";

import openMailIcon from "../../assets/images/open-mail.svg";
import xIcon from "../../assets/images/x-icon.svg";

import { API_BASE_URL } from "../../Variables";

/**
 * Modal that displays notifications when the user clicks on the notifications icon
 * @param {*} notifications - Array of notifications to display 
 * @returns 
 */
function NotificationsModal ({onClose}){
  const dropdownRef = useRef(null);
  const [notifications, setNotifications] = useState([]);
  const token = localStorage.getItem('token');
  const [notificationsChanged, setNotificationsChanged] = useState(false);
  const [error, setError] = useState(null);

  // Close the dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onClose]);

  // Fetch notifications for user when the component mounts
  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/notifications/user`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setError(null);
        setNotifications(response.data);
      } catch (error) {
        setError("Error fetching notifications.");
      }
    };
  
    fetchNotifications();
  }, [token, notificationsChanged]);

  const handleRemoveNotification = (notificationId) => async () => {
    try {
      await axios.delete(`${API_BASE_URL}/notifications/${notificationId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setError(null);
      setNotificationsChanged(!notificationsChanged);
    }
    catch (error) {
      setError("Error removing notification.");
    }
  };

  const handleMarkAsRead = (notificationId) => async () => {
    try {
      await axios.post(`${API_BASE_URL}/notifications/read/${notificationId}`, {}, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setError(null);
      setNotificationsChanged(!notificationsChanged);
    }
    catch (error) {
      setError("Error marking notification as read.");
    }
  };

  return (
    <div className="notifications-dropdown" ref={dropdownRef}>
      <div className="notifications-header">
        <h3>Notifications</h3>
        <img src={xIcon} alt="Close" className="close-icon" onClick={onClose} />
      </div>
      {error && <div className="error">{error}</div>}
      {notifications.length > 0 ? (
        notifications.map((notification, index) => (
          <div key={index} className="notification">
            <div className="notification-title">{notification.title}</div>
            <div className="notification-message">{notification.message}</div>
            <div className="notification-actions">
              <div 
                className={notification.is_read ? "disabled-mark-read-button" : "mark-read-button"} 
                onClick={notification.is_read ? null : handleMarkAsRead(notification.id)}
              >
                <img src={openMailIcon} alt="Mark as Read" className="mark-read-icon" />
              </div>
              <div className="remove-button" onClick={handleRemoveNotification(notification.id)}>
                <img src={xIcon} alt="Remove Notification" className="remove-icon" />
              </div>
            </div>
            <div className="notification-date">{new Date(notification.date_sent).toLocaleString()}</div>
          </div>
        ))
      ) : (
        <div className="notification-item no-notifications">
          No notifications available
        </div>
      )}
      
    </div>
  );
};

export default NotificationsModal;